import { SearchParamAction } from "./actions";
import { IDirectorySearchParams, SearchParamActionTypes } from "./types";

const directorySearchParamsReducer = (
    state: IDirectorySearchParams,
    action: SearchParamAction
) => {
    switch (action.type) {
        case SearchParamActionTypes.SET_SEARCH_PARAM:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default directorySearchParamsReducer;
